export default function <P>(
  Component?: React.ComponentType<P> & { type?: React.ComponentType<P> },
  fallback = 'Component'
) {
  if (!Component) {
    return fallback;
  }
  return (
    Component.displayName ||
    Component.name ||
    (Component.type && (Component.type.displayName || Component.type.name)) ||
    fallback
  );
}
